// extracted by mini-css-extract-plugin
export default {"warning":"warning_button-module__warning--3t-oL"};